
	export default {
		data() {
			return {
				canShow: false,
				subscribeButton: false,
				items: [
					{
						icon: 'clipboard',
						title: 'Unlimited Lessons',
						text: '80,000+ video lessons focused on all skill levels, genres, and more!'
					},
					{
						icon: 'message',
						title: 'World Class Instructors',
						text: 'You’ll be learning from the very best!'
					},
					{
						icon: 'calendar',
						title: 'Interactive Learning Tools',
						text: 'Built in tools like interactive tabs, slow-mo, and more!'
					}
				]
			}
		},
		async created(){
			if(this.$parent.member){
				this.subscribeButton = true
				if(this.$parent.member.tfu_status != 'master') this.canShow = true
			} else this.canShow = true
		}
	}
